import { cva } from "class-variance-authority";

export const genUIInputAreaStyles = {
  // Rendered inside the composer card (see Composer), so the card supplies the
  // background; the bottom border divides the question from the input below it.
  inner: "overflow-y-auto border-b border-border px-4 py-3",
};

// The entrance animation: fade in and slide the height up from 10px to the
// content size (capped at 500px), over 300ms. `max-h-*` are structural values.
export const genUIInputContainer = cva(
  "shrink-0 overflow-hidden transition-all duration-300 ease-out",
  {
    variants: {
      expanded: {
        true: "max-h-[500px] opacity-100",
        false: "max-h-[10px] opacity-0",
      },
    },
    defaultVariants: { expanded: false },
  },
);
